module.exports = __webpack_public_path__ + "static/media/adesivo_eickoff_seguros.ffcade19.png";